module.exports = __webpack_public_path__ + "static/media/djpayback.62dda66c.jpg";